(() => {
  const header = document.querySelector('.cl-header');
  const menuButton = document.querySelector('.cl-menu-toggle');
  const menu = document.querySelector('#ClMainMenu');

  if (header && menuButton && menu) {
    menuButton.addEventListener('click', () => {
      const open = menuButton.getAttribute('aria-expanded') !== 'true';
      menuButton.setAttribute('aria-expanded', String(open));
      header.dataset.menuOpen = String(open);
    });
    menu.addEventListener('click', (event) => {
      if (!event.target.closest('a')) return;
      menuButton.setAttribute('aria-expanded', 'false');
      header.dataset.menuOpen = 'false';
    });
  }

  document.querySelectorAll('[data-sort-by]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.assign(url.toString());
    });
  });

  document.querySelectorAll('[data-variant-selector]').forEach((select) => {
    select.addEventListener('change', () => {
      const option = select.selectedOptions[0];
      const form = select.closest('form');
      const price = form?.closest('.cl-product-page')?.querySelector('[data-product-price]');
      const button = form?.querySelector('[name="add"]');
      if (price && option?.dataset.price) price.textContent = option.dataset.price;
      if (button && option) {
        const available = option.dataset.available === 'true';
        button.disabled = !available;
        button.textContent = available ? button.dataset.addLabel : button.dataset.soldOutLabel;
      }
    });
  });

  document.querySelectorAll('[data-product-image]').forEach((button) => {
    button.addEventListener('click', () => {
      const image = button.closest('.cl-product-page__gallery')?.querySelector('.cl-product-page__main-image');
      if (!image) return;
      image.removeAttribute('srcset');
      image.src = button.dataset.productImage;
      document.querySelectorAll('.cl-thumb').forEach((thumb) => thumb.removeAttribute('aria-current'));
      button.setAttribute('aria-current', 'true');
    });
  });

  document.querySelectorAll('[data-copy-link]').forEach((link) => {
    link.addEventListener('click', async (event) => {
      if (!navigator.clipboard?.writeText) return;
      event.preventDefault();
      try {
        await navigator.clipboard.writeText(link.href);
        link.textContent = link.dataset.copiedLabel || 'Enlace copiado';
      } catch (_) {
        window.location.assign(link.href);
      }
    });
  });
})();
